/** The warehouse's name and code, with the way back to the list. */
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function WarehouseDetailHeader({
  name,
  code,
}: {
  name: string;
  code: string | null;
}) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center gap-4">
      <button
        onClick={() => navigate('/admin/settings/warehouses')}
        className="p-2 hover:bg-stone-100 dark:hover:bg-[#242d28] rounded-lg transition"
      >
        <ArrowLeft size={20} className="text-stone-600 dark:text-stone-400" />
      </button>
      <div>
        <h1 className="text-2xl font-bold text-bark-900 dark:text-stone-100">{name}</h1>
        <p className="text-sm text-stone-500 dark:text-stone-400 mt-1">
          {code ? `Code: ${code}` : 'No code assigned'}
        </p>
      </div>
    </div>
  );
}
